import { customElement, property } from 'lit/decorators.js';
import { comsStore } from '@mfe-4cs/state/ComsStore';
import { TemplatingMixin } from '@mfec/lit/mixins/TemplatingMixin';
import { LitElement } from 'lit';
import { Theme } from '@mfec/types/enum';
import { historyItemTemplate } from './templates/tefOne/historyItem.tmpl';
import { templates } from './templates'; // eslint-disable-line import/no-cycle

export interface PageChangeEvent extends CustomEvent<{ page: number }> {}

@customElement('tef-coms-pagination')
export class TefComsPagination extends TemplatingMixin(LitElement, Theme.OCCL, templates) {
  @property({ type: Object }) history = comsStore.history;
  @property({ type: Number }) itemsPerPage = 5;
  @property({ type: Number }) currentPage = 1;

  async firstUpdated() {
    await this.updateComplete;
  }

  updated() {
    this.currentPage = this.history!.currentPage + 1;
  }

  get items() {
    return this.history?.data?.data.map(historyItemTemplate);
  }

  get pagesNumber() {
    const total = this.history?.data?.total as number;
    if (total) return Math.ceil(total / this.itemsPerPage);
    return 0;
  }

  async handlePageChange(event: PageChangeEvent) {
    this.currentPage = event.detail.page;
    await this.history?.gotoPage(this.currentPage);
    this.requestUpdate();
  }

  override render() {
    return this.getTemplateFn('paginationTemplate')();
  }
}
